import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';

const InputDeleteModal = ({ open = false, handleClose, handleDelete, currentData = null }) => {

	const handleModalClose = () => {
		handleClose();
	}

	return (
		<Dialog
			open={open}
			onClose={handleModalClose}
			aria-labelledby="add-item-modal"
			aria-describedby="add-item-modal-description"
			fullWidth
			maxWidth={"xs"}
		>
			<DialogContent>
				<Typography variant='h6'>Are you sure you want to remove this input field?</Typography>
			</DialogContent>
			<DialogActions>
				<Button id='input-cancel-btn' onClick={handleModalClose}>Cancel</Button>
				<Button id='input-delete-btn' color='error' onClick={() => handleDelete(currentData?.id)} variant='contained'>Remove</Button>
			</DialogActions>
		</Dialog>
	)
}

export default InputDeleteModal;